<template>
    <show-filters v-bind:filters="filters"/>
</template>

<script>

import axios from 'axios'
import EventBus from '../eventBus'
import showFilters from './showFilters.vue'
import setLanguage from '../mixins/setLanguage'
import setPostType from '../mixins/setPostType'
import setBlogId from '../mixins/setBlogId'

export default {
    data() {
        return {
            language: String,
            postType: String,
            filters: {
                allExternalProjectFilters: [],
                productRadio: [],
                productTaxonomiesCheckbox: [],
                productTaxonomiesDropdown: [],
                projectCheckbox: [],
                projectDropdowns: [],
                ranges: [],
                loadingFilters: true,
            },
            errors: [],
        }
    },
    components: {
        'show-filters': showFilters
    },
    mixins: [setLanguage, setPostType, setBlogId],
    created() {
        this.postType = this.setPostType();
        this.language = this.setLanguage();
        this.blogId = this.setBlogId();
        this.loadFiltersFromRESTApi();
        this.loadRanges();
    },
    methods: {
        determineLanguage(values = Object) {
            if (typeof values == 'object') {
                let lang = this.language;
                return values[lang];
            } else {
                console.error('Input is not an object, some translations will not show');
            }
        },
        loadFiltersFromRESTApi() {
            let _this = this;

            //
            //
            // Product filters
            let productMainCategories = function productMainCategories() {
                return axios.get('/wp-admin/admin-ajax.php', {
                    params: {
                        action: 'get_all_website_main_categories',
                        field: 'website_main_category'
                    }
                })
                        .then(response => {
                            let titles = {nl: 'Hoofdcategorie', en: 'Main category', de: 'Hauptkategorie'};
                            let title = _this.determineLanguage(titles);

                            let firstLabels = {
                                nl: 'Alle hoofdcategorieën',
                                en: 'All main categories',
                                de: 'Alle hauptkategorien'
                            };
                            let firstLabel = _this.determineLanguage(firstLabels);

                            let mainCatData = response.data;
                            let defData = []
                            for (const [key, value] of Object.entries(mainCatData)) {
                                let item = {
                                    id: key,
                                    name: value,
                                }
                                defData.push(item);
                            }

                            let acf_filter_object = {
                                name: 'website_main_category',
                                visibilityName: 'website_main_category',
                                title: title,
                                order: 1,
                                items: defData,
                                firstLabel: firstLabel
                            }

                            _this.filters.productRadio.push(acf_filter_object)
                        });
            }

            let productCategories = function productCategories() {
                // Load items from taxonomy 'product_cat'

                let defUrl = window.location.origin + '/wp-json/wp/v2/product_category?per_page=100';
                return axios.get(defUrl)
                        .then(response => {
                            // JSON responses are automatically parsed.

                            let titles = {nl: 'Productlijnen', en: 'Category', de: 'Produktlinien'};
                            let title = _this.determineLanguage(titles);

                            let cat_object = {
                                name: 'product_category',
                                visibilityName: 'product_category',
                                title: title,
                                order: 2,
                                items: response.data
                            }

                            _this.filters.productTaxonomiesCheckbox.push(cat_object);
                        });
            };
            let productThemes = function productThemes() {
                // Load items from taxonomy 'thema_value'
                let defUrl = window.location.origin + '/wp-json/wp/v2/thema_value?per_page=100';
                return axios.get(defUrl)
                        .then(response => {
                            // JSON responses are automatically parsed.

                            let titles = {nl: 'Thema waarden', en: 'Theme values', de: 'Themenwerte'};
                            let title = _this.determineLanguage(titles);

                            // Remove 'aanbesteding' and 'ausschreibung' as filter option
                            for (var item = 0; item < response.data.length; item++) {
                                if (['aanbesteding','ausschreibung'].includes(response.data[item]['slug'])) {
                                    response.data.splice(item, 1);
                                }
                            }

                            let cat_object = {
                                name: 'thema_value',
                                visibilityName: 'thema_value',
                                title: title,
                                order: 3,
                                items: response.data
                            }

                            _this.filters.productTaxonomiesCheckbox.push(cat_object);
                        });
            };
            let playValues = function playValues() {
                // Load items from taxonomy 'thema_value'
                let defUrl = window.location.origin + '/wp-json/wp/v2/play_value?per_page=100';
                return axios.get(defUrl)
                        .then(response => {
                            // JSON responses are automatically parsed.

                            let titles = {
                                nl: 'Belangrijkste speelwaarde',
                                en: 'Most important play value',
                                de: 'Spielwerte'
                            };
                            let title = _this.determineLanguage(titles);

                            let firstLabels = {nl: 'Alle speelwaarden', en: 'All play values', de: 'Alle spielwerte'};
                            let firstLabel = _this.determineLanguage(firstLabels);

                            let cat_object = {
                                name: 'primary_play_value_id',
                                visibilityName: 'primary_play_value_id',
                                title: title,
                                order: 4,
                                items: response.data,
                                firstLabel: firstLabel
                            }

                            _this.filters.productTaxonomiesDropdown.push(cat_object);
                        });
            }

            let secondaryPlayValues = function secondaryPlayValues() {
                // Load items from taxonomy 'thema_value'
                let defUrl = window.location.origin + '/wp-json/wp/v2/play_value?per_page=100';
                return axios.get(defUrl)
                        .then(response => {
                            // JSON responses are automatically parsed.

                            let titles = {
                                nl: 'Overige gewenste speelwaarden',
                                en: 'Other desired play values',
                                de: 'Sekundär spielwert'
                            };
                            let title = _this.determineLanguage(titles);

                            let cat_object = {
                                name: 'secondary_play_value_ids',
                                visibilityName: 'secondary_play_value_ids',
                                title: title,
                                order: 5,
                                items: response.data
                            }

                            _this.filters.productTaxonomiesCheckbox.push(cat_object);
                        });
            }

            //
            //
            // Project filters
            let allExternalProjectFilters = function allExternalProjectFilters() {

                let defUrl = 'https://api.yalpinteractive.com/website/project-filters?language=' + _this.language;

                return axios.get(defUrl)
                        .then(response => {
                            // JSON responses are automatically parsed.
                            let all_filters_array = response.data.data;
                            _this.filters.allExternalProjectFilters = all_filters_array;
                        });
            }

            // Check if all filters al loaded
            let queue;
            if (this.postType == 'catalogus') {
                queue = [productMainCategories(), productCategories(), productThemes(), playValues(), secondaryPlayValues()];
            } else if (this.postType == 'projecten') {
                queue = [allExternalProjectFilters()];
            }

            if (queue) {
                return Promise.all(queue).then(function (v) {
                    // console.log('loading filters done')
                    _this.filters.loadingFilters = false;

                    EventBus.$emit('UPDATE_FILTERS_AFTER_PAGE_LOAD');

                }).catch(function (e) {
                    console.error('Promise all error', e);
                });
            } else {
                // queue empty
                _this.filters.loadingFilters = false;
            }
        },
        loadRange(name, title_nl = 'Title(NL)', title_en = 'Title(EN)', title_de = 'Title(DE)', prefix, start_min_value, start_max_value, order) {
            let _this = this;
            let titles = {nl: title_nl, en: title_en, de: title_de};
            let title = _this.determineLanguage(titles);
            let range = {
                name: name,
                title: title,
                start_min_value: start_min_value,
                start_max_value: start_max_value,
                min_value: start_min_value,
                max_value: start_max_value,
                prefix: prefix,
                order: order
            }
            this.filters.ranges.push(range)
        },
        loadRanges() {
            if (this.postType == 'catalogus') {
                this.loadRange('falling_height', 'Vrije valhoogte', 'Falling height', 'Fallhöhe', 'mm', 0, 3000, 5);
                if (this.blogId !== 3) {
                    this.loadRange('list_price', 'Prijs', 'Price', 'Preis', '€', 0, 300000, 6);
                }
            }
        }
    },
}
</script>
